import type { LandingDict } from './en';

const fr: LandingDict = {
  nav: { chat: "Chat Apps", agentic: "Agentic Apps", build: "Créer une app", org: "My Org", pricing: "Tarifs", privacy: "Confidentialité", contact: "Contact", language: "Langue" },
  hero: {
    titlePre: "Toute la puissance\nde l'",
    titleMark: "IA locale",
    titlePost: ".",
    sub: "Transformez savoir expert, tableurs et réunions en réponses, graphiques et présentations. Rien ne quitte votre Mac.",
    watch: "Voir le film (2 min)",
    pill: "Dernière version",
    chip: "Wi‑Fi coupé · 0 octet envoyé",
    badges: { offline: "Fonctionne hors ligne", server: "Votre serveur, pas le nôtre", free: "Gratuit pour commencer" },
    reqs: "Nécessite un Mac avec Apple Silicon · 16 Go de mémoire minimum · 32 Go ou plus pour les grands modèles recommandés",
  },
  stats: {
    free: "Gratuit",
    freeSub: "Toutes les Chat Apps, les modèles et les mises à jour — pour toujours",
    chatApps: "Chat Apps",
    agenticApps: "Agentic Apps",
    bytesSub: "octet envoyé au cloud quand l'IA tourne sur ce Mac",
    langsSub: "langues d'interface, du français au 日本語",
  },
  film: { kicker: "Le film", title: "Estha en action.", watchOnYouTube: "Regarder sur YouTube", trouble: "Problème de lecture ? Regarder sur YouTube ↗" },
  overview: {
    kicker: "Une app, quatre façons de travailler",
    title: "Du chat aux agents,\njusqu'aux apps de toute l'équipe.",
    explore: "Découvrir",
    chat: { title: "Chat Apps", desc: "Des experts IA fondés sur des bases de connaissances soigneusement sélectionnées — manuels, playbooks et expertise métier.", tag: "Toujours gratuit" },
    agentic: { title: "Agentic Apps", desc: "Des agents IA orientés tâches qui prennent en charge un travail complexe de bout en bout.", tag: "{n}, et d'autres à venir" },
    build: { title: "Créer une app", desc: "Transformez vos propres documents en Chat App avec Quick Bot, ou composez des flux sur le canevas Playground.", tag: "Quick Bot · Playground" },
    org: { title: "My Org", desc: "L'espace d'apps de votre organisation, à ses couleurs, avec des apps validées et un accès maîtrisé.", tag: "Enterprise" },
  },
  chat: {
    kicker: "Chat Apps",
    title: "Des experts IA, nourris de vrai savoir.",
    freePill: "Toujours gratuit",
    lede: "Chaque Chat App embarque sa propre base de connaissances, indexée directement sur votre Mac.",
    feats: {
      kb: { title: "Bases de connaissances locales", desc: "L'installation d'une app crée sa base de connaissances en local — les réponses s'appuient sur des contenus sélectionnés." },
      files: { title: "Vos propres fichiers", desc: "Joignez images, PDF, DOCX, TXT ou MD — les longs documents profitent d'une recherche intelligente." },
      browse: { title: "Parcourir, épingler, mettre en favori", desc: "Des catégories de l'Évaluation à la Carrière, un badge NEW pour les nouveautés, ⌘K pour tout rechercher." },
    },
  },
  agentic: {
    kicker: "Agentic Apps",
    title: "{n} Agentic Apps.\nEt ce n'est qu'un début.",
    lede: "D'un tableur, d'un PDF, d'un enregistrement ou d'une idée à un graphique, une présentation, un document ou un prototype aboutis — en toute confidentialité, sur votre Mac.",
    seeThem: "Les voir à l'œuvre",
  },
  build: {
    kicker: "Créer une app",
    title: "Créez votre propre Chat App.\nSur votre Mac.",
    lede: "Transformez vos fichiers en Chat App — indexée en local, publiée quand vous le décidez.",
    quick: {
      badge: "Recommandé",
      desc: "Téléversez une base de connaissances et rédigez une invite système, puis publiez. Idéal pour transformer rapidement des documents en un bot de questions-réponses.",
      items: ["Formulaire d'une page, terminé en quelques étapes", "Questions-réponses sur base de connaissances prêtes à l'emploi", "Modèles d'invites intégrés pour vous inspirer"],
    },
    advanced: {
      title: "Avancé · Playground",
      desc: "Éditeur de nœuds visuel pour composer librement plusieurs nœuds, branches, AB test et routage par mots-clés.",
      items: ["Canevas de nœuds", "Multi-nœuds / branche / AB test", "Champs détaillés et débogage"],
    },
    guideTitle: "Un guide IA local vous accompagne à chaque étape.",
    guideText: "Décrivez ce que doit faire votre app : il vous indique quels nœuds faire glisser et comment les relier. La création d'apps est incluse dans Premium.",
  },
  private: {
    kicker: "Confidentiel par conception",
    title: "Pas de cloud pour vos données.\nPas de pistage de votre travail.",
    lede: "Vous choisissez où tourne l'IA. Par défaut, Estha choisit le bon modèle pour chaque fonction — et vous pouvez en changer à tout moment dans l'app.",
    boundary: "Frontière des données = votre réseau",
    local: { title: "Sur ce Mac", desc: "Entièrement hors ligne, rien ne quitte cet appareil. Utilise la mémoire de cet ordinateur.", best: "Idéal pour les Mac disposant de beaucoup de mémoire" },
    server: { title: "Sur mon Estha Server", desc: "Déléguez les tâches lourdes à un Mac plus puissant de votre réseau et gardez ce Mac léger.", best: "Idéal pour les portables et les Mac à mémoire limitée" },
    cluster: { desc: "Connectez-vous à un cluster Mac Studio pour déléguer les inférences lourdes tout en gardant vos données en local.", best: "Détecte automatiquement les nœuds Estha Studio Master de votre réseau" },
    models: {
      every: "Compatible avec tous les Mac pris en charge",
      whisper: "Whisper pour la transcription",
      recommended: "Les modèles recommandés",
      larger: "Modèles Qwen et Gemma plus grands",
      vision: "Modèles de vision pour les images",
      open: "Des modèles ouverts, optimisés pour Apple Silicon",
      openItems: ["Téléchargez et changez de modèle dans l'app", "Modèles dédiés au code et aux embeddings", "Téléchargement des modèles toujours gratuit"],
    },
  },
  org: {
    kicker: "My Org",
    title: "L'espace d'apps IA de votre organisation.",
    lede: "Une section d'Estha à vos couleurs, qui réunit les apps validées par votre organisation pour ses équipes.",
    signIn: "Se connecter à My Org Admin",
    talk: "Contacter l'équipe Estha",
    feats: {
      review: { title: "Validation avant publication", desc: "Chaque nouvelle app, mise à jour ou suppression passe par un administrateur. Tout refus est accompagné d'un commentaire écrit." },
      access: { title: "Accès par groupe ou par personne", desc: "Décidez précisément qui voit chaque app — par service, par équipe ou par personne." },
      brand: { title: "Votre marque, dans l'app", desc: "Nom de l'organisation, message d'accueil, logo, bannière et couleur de thème — à prévisualiser avant la mise en ligne." },
    },
  },
  pricing: {
    kicker: "Abonnement",
    title: "Commencez gratuitement. Débloquez tout quand vous le souhaitez.",
    free: { name: "Gratuit", sub: "Gratuit, pour toujours.", items: ["Toutes les Chat Apps", "Traitement de documents, gratuit pour toujours", "Téléchargements de modèles, logiciel et mises à jour — toujours gratuits"] },
    premium: {
      name: "Premium", flag: "Essai gratuit de 14 jours", firstYear: "la première année",
      sub: "Puis 30 $/an. Essai gratuit de 14 jours après vérification de votre adresse e-mail.",
      items: ["Tout ce qui est inclus dans Gratuit", "Toutes les Agentic Apps actuelles et futures", "Créateur de Chat Apps — créez, modifiez, prévisualisez, enregistrez et publiez des chatbots locaux"],
      cta: "Démarrer l'essai dans l'app",
    },
    enterprise: {
      name: "Enterprise", price: "Parlons-en", sub: "Pour les organisations qui déploient Estha auprès de leurs équipes.",
      items: ["Tout ce qui est inclus dans Premium", "Chat Apps et Agentic Apps personnalisées pour votre équipe", "Fonctionnalité de l'application Estha Server", "Espace d'apps My Org et My Org Admin"],
    },
  },
  faq: {
    title: "Bon à savoir\navant de télécharger.",
    spec: { chip: "Puce", memory: "Mémoire", memMin: "16 Go minimum", memRec: "32 Go ou plus pour les modèles recommandés", languages: "Langues", langsVal: "13 langues d'interface", version: "Dernière version" },
    qa: [
      { q: "Des données quittent-elles mon Mac ?", a: "Lorsque l'IA tourne sur ce Mac, tout se fait hors ligne — rien ne quitte l'appareil. Si vous choisissez un Estha Server ou un Mac Studio Cluster, les tâches sont envoyées uniquement à cette machine, sur votre propre réseau." },
      { q: "Qu'est-ce qui nécessite une connexion Internet ?", a: "Très peu de choses : la connexion et la vérification de l'e-mail pour l'essai Premium, le téléchargement des modèles et la recherche de mises à jour. Vos requêtes, fichiers et résultats ne sont jamais envoyés — une fois le modèle téléchargé, l'IA fonctionne entièrement hors ligne." },
      { q: "Qu'est-ce qui est gratuit, qu'apporte Premium ?", a: "Toutes les Chat Apps, le Traitement de documents, les téléchargements de modèles et les mises à jour sont gratuits. Premium débloque toutes les Agentic Apps actuelles et futures ainsi que le créateur de Chat Apps, avec un essai gratuit de 14 jours." },
      { q: "Quels modèles d'IA utilise Estha ?", a: "Des modèles open source de premier plan comme Qwen et Gemma, ainsi que Whisper pour la transcription, exécutés par le moteur MLX d'Apple. Vous les téléchargez et en changez directement dans l'app." },
      { q: "Puis-je créer ma propre app ?", a: "Oui. Avec Quick Bot, transformez jusqu'à trois fichiers en Chat App dotée d'une base de connaissances, en quelques étapes. Ou utilisez le canevas de nœuds de Playground pour les branches, les AB tests et les quiz. Un guide de création local vous accompagne tout du long." },
      { q: "Comment les organisations le déploient-elles ?", a: "Avec Enterprise, les administrateurs gèrent utilisateurs et groupes dans My Org Admin et valident chaque app avant sa publication ; les membres retrouvent dans Estha un espace My Org aux couleurs de l'organisation. Écrivez-nous à {email}." },
    ],
  },
  final: { title: "Prêt pour l'IA en local ?", reqs: "Fonctionne sur tout Mac avec Apple Silicon · 16 Go de RAM minimum" },
  footer: {
    tagline: "Toute la puissance de l'IA, en local — sur l'appareil, propulsée par MLX, confidentielle par conception.",
    product: "Produit", createApp: "Créer une app", pricing: "Tarifs",
    orgs: "My Org", signIn: "Se connecter à My Org Admin",
    security: "Sécurité", changelog: "Nouveautés", docs: "Documentation", support: "Assistance",
    company: "Société", privacy: "Politique de confidentialité", terms: "Conditions d'utilisation",
    rights: "© 2026 Estha. Tous droits réservés.",
  },
  proof: { press: "Ils en parlent", voices: "Ce qu'en disent les équipes" },
  contact: {
    title: "Écrire à l'équipe Estha", copy: "Copier l'adresse e-mail", copied: "Copié",
    gmail: "Écrire dans Gmail", mailApp: "Ouvrir dans l'app Mail",
    subject: "Demande — Estha for Mac",
  },
  share: {
    button: "Partager", title: "Partager Estha",
    sub: "Choisissez une carte et publiez-la — ou envoyez simplement le lien.",
    style: "Carte", size: "Format",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "Confidentialité" },
    landscape: "Paysage", portrait: "Portrait",
    shareImage: "Partager l'image…", download: "Télécharger l'image", copyImage: "Copier l'image", copied: "Copié",
    copyLink: "Copier le lien", link: "Lien", postTo: "Publier sur",
    email: "E-mail",
    text: "Estha fait tourner des modèles d'IA open source entièrement sur votre Mac — privé, hors ligne et gratuit.",
    cardCta: "Téléchargement gratuit pour les Mac avec puce Apple",
    close: "Fermer",
  },
  apps: {
    dataAnalyst: { name: "Analyste de données", description: "Importez des fichiers CSV/Excel et posez vos questions en langage naturel. Génère automatiquement des graphiques, des analyses statistiques et des insights — le tout traité localement sur votre Mac.", tags: ["CSV / Excel", "Graphiques auto", "Requête en langage naturel", "EN / 中文"] },
    pptMaker: { name: "PPT Maker", description: "Décrivez le sujet de votre présentation et obtenez un diaporama PowerPoint structuré de façon professionnelle. Un pipeline IA multi-étapes génère le plan, le contenu de chaque diapo et un fichier .pptx soigné.", tags: ["Sortie .pptx", "Mise en page auto", "Pipeline multi-étapes"] },
    pdfReader: { name: "Lecteur PDF", description: "Ouvrez un PDF et dialoguez avec lui. Chaque réponse s'appuie sur le document avec des citations cliquables menant au passage source exact — le tout traité localement sur votre Mac.", tags: ["Q&R PDF", "Citations vérifiables", "Question sur sélection", "100 % local"] },
    documentProcessing: { name: "Traitement de documents", description: "Votre expert documentaire tout-en-un. Rédigez des articles de blog, des textes pour réseaux sociaux, des clauses juridiques et des documents professionnels à partir de zéro. Modifiez et optimisez des fichiers existants, traduisez entre les langues et révisez la qualité du contenu — le tout en toute confidentialité sur votre Mac.", tags: ["Rédaction", "Édition et optimisation", "Traduction", "Révision et audit"] },
    meetingIntelligence: { name: "Meeting Intelligence", description: "Enregistrez, transcrivez et analysez vos réunions avec l'IA. Générez automatiquement des comptes rendus, des tâches à réaliser et les décisions clés — en toute confidentialité, aucun audio ne quitte jamais votre appareil.", tags: ["Transcription", "Comptes rendus", "Tâches à réaliser", "100 % privé"] },
    vibeCoding: { name: "Vibe Coding : Prototype", description: "Créez des aperçus interactifs avec l'IA. Décrivez une interface en langage naturel, obtenez un prototype cliquable et continuez à l'améliorer. Produit un seul fichier .html autonome, généré entièrement sur votre Mac.", tags: ["Fichier .html unique", "Aperçu interactif", "Édition au clic", "100 % local"] },
    translate: { name: "Traduction", description: "Traduisez du texte et des documents Word, texte ou Markdown avec un glossaire partagé qui garde vos termes cohérents — le tout traité localement sur votre Mac.", tags: ["Texte et documents", ".docx / .txt / .md", "Glossaire", "100 % local"] },
  },
  screens: {
    chat: [
      { label: "Parcourir la boutique", caption: "Parcourez, installez, épinglez — toujours gratuit" },
      { label: "Installer", caption: "Les bases de connaissances sont créées en local à l'installation" },
      { label: "Demander", caption: "Des réponses fondées sur son playbook" },
    ],
    build: [
      { label: "Créer une app", caption: "Quick Bot ou Avancé — tous deux prêts à discuter" },
      { label: "Quick Bot", caption: "Importez une base. Rédigez une invite. Publiez." },
      { label: "Playground", caption: "Nœuds, branches et connaissances — en visuel" },
      { label: "Publiée", caption: "Publiée et prête à discuter" },
    ],
    analyst: [
      { label: "Poser une question", caption: "Interrogez vos données en langage naturel" },
      { label: "Analyse", caption: "Analysées sur votre Mac" },
      { label: "Graphique et analyse", caption: "La réponse, le graphique et la méthode" },
    ],
    ppt: [
      { label: "Configurer", caption: "Sujet, diapos, langue, ton, thème" },
      { label: "Revoir le plan", caption: "Modifiez le plan avant toute génération" },
      { label: "Aperçu", caption: "Un .pptx abouti et modifiable — sur votre Mac" },
    ],
    pdf: [
      { label: "Ouvrir un PDF", caption: "Articles, rapports, manuels et documents numérisés" },
      { label: "Lecture", caption: "Lu en local, page par page" },
      { label: "Réponse sourcée", caption: "Chaque réponse renvoie à la clause exacte" },
    ],
    doc: [
      { label: "Sélectionner un passage", caption: "Sélectionnez du texte et dites ce que vous voulez" },
      { label: "Réécriture", caption: "Réécrit directement dans le document" },
      { label: "Accepter ou refuser", caption: "Réécrire, peaufiner, traduire — acceptez ou refusez" },
    ],
    meeting: [
      { label: "Enregistrer", caption: "Transcription en direct, sur ce Mac" },
      { label: "Choisir les sorties", caption: "Choisissez ce qui sera généré" },
      { label: "Résumé", caption: "Décisions et tâches, rédigées pour vous" },
      { label: "Tâches", caption: "Responsables et échéances, preuves à l'appui" },
    ],
    vibe: [
      { label: "Décrire", caption: "Décrivez une interface en langage naturel" },
      { label: "Génération", caption: "Entièrement créé sur ce Mac" },
      { label: "Prototype", caption: "Cliquable, versionné, un seul fichier .html" },
      { label: "Édition au clic", caption: "Sélectionnez un élément et dites quoi changer" },
    ],
    translate: [
      { label: "Traduire du texte", caption: "Les mots en violet viennent de votre glossaire" },
      { label: "Traduire un document", caption: ".docx, .txt ou .md — l’original reste intact" },
      { label: "Glossaire", caption: "Votre glossaire garde chaque terme cohérent" },
    ],
    private: [
      { label: "Sur ce Mac", caption: "Entièrement hors ligne. Rien ne quitte cet appareil." },
      { label: "Mac Studio Cluster", caption: "Des modèles plus lourds — sur site" },
    ],
    org: [
      { label: "Espace d'apps", caption: "Un espace à vos couleurs, des apps pour l'équipe" },
      { label: "Offre Enterprise", caption: "Les membres n'ouvrent que les apps autorisées" },
    ],
  },
};

export default fr;
